import { render, staticRenderFns } from "./createOrEdit.vue?vue&type=template&id=41a6b378&scoped=true&"
import script from "./createOrEdit.vue?vue&type=script&lang=ts&"
export * from "./createOrEdit.vue?vue&type=script&lang=ts&"
import style0 from "./createOrEdit.vue?vue&type=style&index=0&id=41a6b378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a6b378",
  null
  
)

export default component.exports